import React, { FC } from 'react';
import { useAppDispatch, useAppSelector } from '../app/lib/hooks';
import { setGuidePreferences } from '../app/lib/reducers/recruitmentReducer';

interface CheckboxProps {
  label: string;
  categoryName: string; // Use categoryName for clarity
}

const Checkbox: FC<CheckboxProps> = ({ label, categoryName }) => {
  const dispatch = useAppDispatch();
  // Retrieve the current state for this checkbox from the Redux store
  const isChecked = useAppSelector(state => state.recruitment.guidePreferences[categoryName]?.[label] ?? false);

  // Correctly handle the change event and dispatch the action with all three parameters
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Extract the checked value from the event
    const isChecked = e.target.checked;
    // Dispatch the action with the category name, label, and checked status
    dispatch(setGuidePreferences(categoryName, label, isChecked));
  };

  return (
    <div className="flex items-center">
      <input
        id={`${categoryName}-${label}`}
        type="checkbox"
        checked={isChecked}
        onChange={handleChange}
        className="focus:ring-primary-500 h-4 w-4 text-primary-600 border-gray-300 rounded"
      />
      <label htmlFor={`${categoryName}-${label}`} className="ml-2 block text-sm text-gray-900">
        {label}
      </label>
    </div>
  );
};

export default Checkbox;
